import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import DataRoomDocumentsContext from '../../providers/DataRoomDocuments/DataRoomDocuments.context';
import DataRoomSelectedDocumentsContext from '../../providers/DataRoomSelectedDocuments/DataRoomSelectedDocuments.context';
import { getCanDownloadNode } from 'utils';

import './SelectAllButton.styles.scss';

type SelectAllButtonProps = {
  className?: string;
};

const SelectAllButton: React.FC<SelectAllButtonProps> = (props) => {
  const { className } = props;

  const { doesntHaveAccess } = useContext(DataRoomContext);
  const { isDataRoomEmpty, currentlyDisplayedNodes } = useContext(
    DataRoomDocumentsContext,
  );
  const { shouldAllowBulkActions, selectAll } = useContext(
    DataRoomSelectedDocumentsContext,
  );

  const classes = classNames('select-all-button', className);

  const { t } = useTranslation();

  const hasSelectAll = useMemo(
    () =>
      currentlyDisplayedNodes?.every(
        (node) => node.hasAuthorizedActions || getCanDownloadNode(node),
      ),
    [currentlyDisplayedNodes],
  );

  if (
    doesntHaveAccess ||
    isDataRoomEmpty ||
    !shouldAllowBulkActions ||
    !hasSelectAll
  )
    return null;

  return (
    <Button className={classes} onClick={selectAll}>
      {t('selectAll')}
    </Button>
  );
};

export default SelectAllButton;
